<template>
    <div class="flex flex-col items-center justify-center flex-1 h-full p-4">
        <CircleCheck :size="48" class="text-green-500 dark:text-green-400 mb-4" />
        <p class="text-center">
            {{ $t('twoFactorAuthenticationResetSuccess') }}
        </p>
        <Button
            as="a"
            class="w-full md:w-auto mt-8"
            href="#login"
            severity="secondary"
            size="small"
            :label="$t('backToLogin')"
            variant="text" />
    </div>
</template>

<script lang="ts">
import { CircleCheck } from 'lucide-vue-next';

export default {
    components: {
        CircleCheck
    }
};
</script>
